import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ComposicionPagosService } from 'src/app/reportes/pages/composicionPagos/composicion-pagos.service';
import { DateService } from 'src/app/reportes/shared/date.service';

import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexYAxis,
  ApexPlotOptions,
  ApexResponsive,
  ApexXAxis,
  ApexLegend,
  ApexFill,
  ApexTooltip,
  ApexStroke,
  ApexGrid
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  legend: ApexLegend;
  yaxis: ApexYAxis | ApexYAxis[];
  tooltip: ApexTooltip | ApexTooltip[];
  fill: ApexFill;
  stroke: ApexStroke;
  grid: ApexGrid;
};

@Component({
  selector: 'app-grafico-hist-composicion-pagos',
  templateUrl: './grafico-hist-composicion-pagos.component.html',
  styleUrls: ['./grafico-hist-composicion-pagos.component.scss'],
})
export class GraficoHistComposicionPagosComponent implements OnInit {

  @ViewChild("chart") chart: ChartComponent;
  @Input() showHistGrafico: boolean;
  // public totalyaxis;
  public chartOptions: Partial<ChartOptions>;
  private initDate: string;
  private Finaldate: string;
  public valueHeight = '300px';
  data: any;
  arraySeries = [];


  constructor(
    private _composicionPagosService: ComposicionPagosService,
    private dateService: DateService
  ) { }

  ngOnInit() {
    this.initDate = this.dateService.FinTreceMeses;
    this.Finaldate = this.dateService.getFinaldate();

    this._composicionPagosService.dataHistGrafica.subscribe(response => {
      if (response) {
        this.data = response
        this.getArrayApex()
      }
    })

    this.chartOptions = {
      series: [...this.arraySeries],

      chart: {
        type: "line",
        height: this.valueHeight,
        width: '100%',
        stacked: true,
        background: '#fff',
        fontFamily: 'ayudate',
        foreColor: '#151618',
        redrawOnParentResize: true,
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 400,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        },
      },

      stroke: {
        curve: "smooth"
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            },
            chart: {
              height: this.valueHeight
            }
          }
        }
      ],
      plotOptions: {
        bar: {
          horizontal: false
        }
      },

      xaxis: {
        type: "category",
        categories: []
      },
      yaxis: [
        {
          decimalsInFloat: 2
        }

      ],
      legend: {
        position: "right",
        offsetY: 40
      },
      fill: {
        opacity: 1
      },
    };
  }

  ngOnChanges(changes): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    

  }

  getArrayApex() {
    let totalEntrada_exempleado = this.getData(this.data, 'totalEntrada_exempleado');
    let totalSalidaAdministrativa = this.getData(this.data, 'totalSalidaAdministrativa');
    let totalSalidaExtrajudicial = this.getData(this.data, 'totalSalidaExtrajudicial');
    let totalAumentoExmpleado = this.getData(this.data, 'totalAumentoExmpleado');

    let categorias = this.getCategories(this.data);

    let totalyaxis = this.mathYaxis(totalEntrada_exempleado, totalSalidaAdministrativa, totalSalidaExtrajudicial, totalAumentoExmpleado)

    this.arraySeries = [
      {
        name: 'Entrada Exempleado',
        type: 'column',
        data: totalEntrada_exempleado,
        color: '#3476E4'
      },
      {
        name: 'Aumento Exmpleado',
        type: 'column',
        data: totalAumentoExmpleado,
        color: '#00CEFF'
      },
      {
        name: 'Salida Administrativa',
        type: 'column',
        data: totalSalidaAdministrativa,
        color: '#05db8e'
      },
      {
        name: 'Salida Extrajudicial',
        type: 'column',
        data: totalSalidaExtrajudicial,
        color: '#ffd000'
      },
    ];

    this.chartOptions = {

      series: [...this.arraySeries],
      chart: {
        type: "line",
        height: this.valueHeight,
        width: '100%',
        stacked: true,
        background: '#fff',
        fontFamily: 'ayudate',
        foreColor: '#151618',
        redrawOnParentResize: true,
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 400,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        },
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false,
        },

      },

      stroke: {
        curve: "smooth"
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },

      responsive: [
        {
          breakpoint: 500,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            },
            chart: {
              height: this.valueHeight
            }
          }
        },
        {
          breakpoint: 600,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            },
            chart: {
              height: this.valueHeight
            }
          }
        },
        {
          breakpoint: 992,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            },
            chart: {
              height: this.valueHeight
            }
          }
        },
        {
          breakpoint: 1200,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            },
            chart: {
              height: this.valueHeight
            }
          }
        }
      ],

      plotOptions: {
        bar: {
          horizontal: false
        },
      },
      xaxis: {
        type: "category",
        categories: categorias
      },
      yaxis: [
        {
          decimalsInFloat: 2,
          max: totalyaxis,
          // labels: {
          //   formatter: labelFormatter,
          // }
        }
      ],
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {

          let nTotalSaldoBaja = moneyFormatMxn(totalEntrada_exempleado[dataPointIndex])
          let ntotalNK_Pendiente = moneyFormatMxn(totalAumentoExmpleado[dataPointIndex])
          let ntotalCobranzaAdministrativa = moneyFormatMxn(totalSalidaAdministrativa[dataPointIndex])
          let ntotalCobranzaExtrajudicial = moneyFormatMxn(totalSalidaExtrajudicial[dataPointIndex])

          
          return (
            '<div class="header-toltip">' + '<span >' + w.globals.categoryLabels[dataPointIndex] + '</span>' + '</div>' +
            '<ul>' +
            '<li class="li-toltip-dark-blue"><span class="span-tooltip"> ' + w.globals.seriesNames[0] + ': ' + nTotalSaldoBaja + '</span></li>' +

            '<li class="li-toltip-blue"><span class="span-tooltip"> ' + w.globals.seriesNames[1] + ': ' + ntotalNK_Pendiente + '</span></li>' +

            '<li class="li-toltip-green"><span class="span-tooltip"> ' + w.globals.seriesNames[2] + ': ' + ntotalCobranzaAdministrativa + '</span></li>' +

            '<li class="li-toltip-yellow"><span class="span-tooltip"> ' + w.globals.seriesNames[3] + ': ' + ntotalCobranzaExtrajudicial + '</span></li>' +
            '</ul>'
            // '<div class="arrow_box"> <div class="circulo"> </div>' +'<span>' + w.globals.seriesNames[0] + ': ' + creditosNuevos[dataPointIndex].toFixed(2) + '</span> ' + '</div>' +
            // '<div class="arrow_box">' + '<span>' + w.globals.seriesNames[1] + ': ' + creditosRecargas[dataPointIndex].toFixed(2) + '</span>' + '</div>' +
            // '<div class="arrow_box">' + '<span>' + w.globals.seriesNames[2] + ': ' + totalCreditosNuevosRecargas[dataPointIndex].toFixed(2) + '</span>' + '</div>' +
            // '<div class="arrow_box">' + '<span>' + w.globals.seriesNames[3] + ': ' + metasMeses[dataPointIndex].toFixed(2) + '</span>' + '</div>'
          )
        }
      },

      legend: {
        position: "right",
        offsetY: 40
      },
      fill: {
        opacity: 1
      },




    };




    // return arraySeries;


  }

  mathYaxis(creditosNuevos, creditosRecargas, totalCreditosNuevosRecargas, metasMeses) {
    let Cn = Math.max(...creditosNuevos);
    let Cr = Math.max(...creditosRecargas);
    let Tn = Math.max(...totalCreditosNuevosRecargas);
    let Mm = Math.max(...metasMeses);

    let suma = Math.max(Cn, Cr, Tn, Mm)

    let val = parseInt(suma.toString().split('').shift()) + 1
    let longitud = Math.round(suma).toString().length
    // Math.round(      
    let result = val.toString().padEnd(longitud, '0')

    return parseInt(result)
  }


  getData(array, columna) {
    
    let nuevo = array
    let arrayCreditosNuevos = [];
    let f;
    nuevo.forEach(element => {
      f = element[columna]

      return arrayCreditosNuevos.push(f);
    });
    return arrayCreditosNuevos;
  }

  getCategories(array) {
    let nuevo = array
    let arrayMetas = [];
    let f;
    nuevo.forEach(element => {
      f = element.yearMonth
      return arrayMetas.push(f);
    });
    return arrayMetas;
  }

}

function moneyFormatMxn(cant) {
  const formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2
  });
  return formatter.format(cant);
}

